import { Link } from "gatsby";
import styled from "styled-components";

import { Box, Image, Logo } from "@vinomofo/components";
import WhiskyMofoLogo from "../../images/whiskymofo-logo.png";

export interface HeaderLogoProps {
  height?: string | Array<string>;
  isWhiskymofoEnabled?: boolean;
}

const HeaderLink = styled(Link)`
  display: block;
  height: 100%;

  @media ${({ theme }) => theme.mq.max.mobile} {
    height: 30px;
  }

  svg {
    width: auto;
    height: inherit;
    vertical-align: middle;
  }
`;

const StyledWhiskyMofoLogo = styled(Image)`
  width: auto;
  height: inherit;
  vertical-align: middle;
`;

export const HeaderLogo = ({
  height = "24px",
  isWhiskymofoEnabled,
}: HeaderLogoProps): JSX.Element => {
  return (
    <Box height={height}>
      <HeaderLink to={isWhiskymofoEnabled ? "/whiskymofo" : "/"}>
        {isWhiskymofoEnabled ? (
          <StyledWhiskyMofoLogo
            src={WhiskyMofoLogo}
            alt="Whisky Mofo Logo"
            width="100%"
          />
        ) : (
          <Logo />
        )}
      </HeaderLink>
    </Box>
  );
};
